import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { store } from 'store'
import { ConfigProvider } from 'contexts/ConfigContext'
import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import 'simplebar/src/simplebar.css'
import 'assets/third-party/apex-chart.css'
import 'assets/third-party/react-table.css'

const queryClient = new QueryClient()

ReactDOM.render(
  <ReduxProvider store={store}>
    <ConfigProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools />
        </QueryClientProvider>
      </BrowserRouter>
    </ConfigProvider>
  </ReduxProvider>,
  document.getElementById('root')
)

reportWebVitals()
